<div class="feedback-rating-scale" role="group" aria-label="Rating">
	@for (item of ratingScale; track item.score) {
		@if (readonly) {
			<div class="feedback-rating-scale__item" [class.feedback-rating-scale__item--selected]="selected === item.score">
				<span class="feedback-rating-scale__score">{{ item.score }}</span>
				<span class="feedback-rating-scale__label">{{ item.label }}</span>
			</div>
		} @else {
			<button
				type="button"
				class="feedback-rating-scale__item"
				[class.feedback-rating-scale__item--selected]="selected === item.score"
				[attr.aria-label]="item.score + ' ' + item.label"
				[attr.aria-pressed]="selected === item.score"
				(click)="choose(item.score)"
			>
				<span class="feedback-rating-scale__score">{{ item.score }}</span>
				<span class="feedback-rating-scale__label">{{ item.label }}</span>
			</button>
		}
	}
</div>
